<template>
  <div class="bg-gray-100 min-h-screen p-8">
    <!-- Header Section -->
    <header class="text-center mb-10">
      <h1 class="text-3xl font-bold text-green-700">Admission Process</h1>
      <p class="text-gray-700 mt-2">Our step-by-step guide to beginning your journey with us</p>
    </header>

    <!-- Step 1: Initial Contact -->
    <section class="bg-white rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Step 1: Initial Contact</h2>
      <p class="text-gray-700">
        Reach out to us through phone or email to schedule an initial consultation. Our team will answer your questions, discuss your needs, and provide details on our services.
      </p>
    </section>

    <!-- Step 2: Assessment -->
    <section class="bg-white rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Step 2: Assessment</h2>
      <p class="text-gray-700">
        In this stage, we conduct a comprehensive assessment with the individual to understand their health, background, and specific needs. This helps us create a personalized treatment plan.
      </p>
    </section>

    <!-- Step 3: Documentation and Registration -->
    <section class="bg-white rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Step 3: Documentation and Registration</h2>
      <p class="text-gray-700">
        After the assessment, we will guide you through the documentation process. Necessary forms will be filled out, and we’ll ensure all required information is securely collected.
      </p>
    </section>

    <!-- Step 4: Admission and Orientation -->
    <section class="bg-white rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Step 4: Admission and Orientation</h2>
      <p class="text-gray-700">
        Once registered, we welcome you to our center. Our staff will provide an orientation, helping you get familiar with the facility, the daily schedule, and introduce you to our team.
      </p>
    </section>

    <!-- Step 5: Personalized Treatment Begins -->
    <section class="bg-green-50 rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Step 5: Personalized Treatment Begins</h2>
      <p class="text-gray-700">
        With all the preparations complete, treatment officially begins. You’ll receive individualized care and support as you start your recovery journey.
      </p>
    </section>

    <!-- Contact Information -->
    <section class="text-center mt-12">
      <p class="text-gray-700">For more details or assistance, please contact us:</p>
      <p class="text-green-700 font-semibold mt-2">Email: tpccrecovery@gmail.com | Phone: 0746 298 500 / 0723 168 719</p>
    </section>
  </div>
</template>

<script>
export default {
  name: "AdmissionProcess",
};
</script>

<style scoped>
/* Custom styles if needed */
</style>
